import { Loader } from '@googlemaps/js-api-loader';
import { useEffect, useState } from 'react';
import { getGoogleApiKey } from 'src/bff';

const libraries = ['places'];

export default function LoadScriptInstance(props: any) {
	const [isLoaded, setIsLoaded] = useState(false);

	const loader = new Loader({
		apiKey: getGoogleApiKey(),
		libraries: ['places'],
		language: 'es',
	});

	useEffect(() => {
		const useLoader = async () => {
			if (!window.google || !window.google.maps) {
				// Solo cargamos si no existe
				await loader.load();
			}

			// ✅ Validar si la librería 'places' ya está disponible
			const hasPlacesLib =
				!!window.google.maps.places &&
				typeof window.google.maps.places.Autocomplete === 'function';
			if (!hasPlacesLib) {
				await window.google.maps.importLibrary('places');
			}

			setIsLoaded(true);
			props.onMapLoad();
		};
		useLoader();
	}, []);

	return isLoaded ? props.children : null;
}
